import { getPDF } from "../../api/profileApi";
import ReadingStatus from "../../components/ReadingListDownload/reading_status";

export const triggerDownload = (
  typeCode,
  fileName,
  setCurTypeCode,
  setLoading
) => {
  setCurTypeCode(typeCode);
  setLoading(true);
  getPDF(typeCode).then((response) => {
    const link = document.createElement("a");
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    setLoading(false);
    setCurTypeCode("");
  });
};

export const filenameFromUrl = (url) => url.split("/").slice(-1)[0];

export const filenameFromUrlRemoveExt = (url, ext) =>
  url.split("/").slice(-1)[0].replace(`.${ext}`, "");

export const getReadingListWithStatus = (readingList, readDocuments) =>
  readingList
    .map((download) => ({
      ...download,
      status: readDocuments.includes(filenameFromUrl(download.link))
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));
